const composedBlock = [
  "M8.5 3v10h4V3zm1 1h2v8h-2zm-6-1h4v10h-4zm12 12a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1zm-13-1h11V2h-11z"
];
export {
  composedBlock
};
//# sourceMappingURL=composedBlock.js.map
